import Stack from "@mui/material/Stack";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import KhattabatAlbumDialog from "../../../../core/et3-pop-up-album/KhattabatAlbumDialog";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import KhattabatUserFeatures from "./KhattabatUserFeatures";
import KhattabatUserLinks from "./KhattabatUserLinks";
import KhattabatUserPager from "./KhattabatUserPager";
import KhattabatUserSummary from "./KhattabatUserSummary";
import KhattabatUserTables from "./KhattabatUserTables";

const KhattabatUserAdvancedData = withLiteObserverAndTheme(() => {
  const isVisible = getUserAdvancedStore().userIDs.get().length > 0;

  return !isVisible ? null : (
    <Stack spacing={3}>
      <KhattabatUserPager />
      <KhattabatUserSummary />
      <KhattabatUserFeatures />
      <KhattabatUserLinks />
      <KhattabatUserTables />
      <KhattabatAlbumDialog />
    </Stack>
  );
});

export default KhattabatUserAdvancedData;
